var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwnedMembership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "eid medlemskap",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346627 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0V0ZM8 2.4C8.47468 2.4 8.93869 2.54076 9.33337 2.80447C9.72805 3.06819 10.0357 3.44302 10.2173 3.88156C10.399 4.3201 10.4465 4.80266 10.3539 5.26822C10.2613 5.73377 10.0327 6.16141 9.69706 6.49706C9.36141 6.8327 8.93377 7.06128 8.46822 7.15388C8.00266 7.24649 7.5201 7.19896 7.08156 7.01731C6.64302 6.83566 6.26819 6.52805 6.00448 6.13337C5.74076 5.73869 5.6 5.27467 5.6 4.8C5.6 4.16348 5.85286 3.55303 6.30295 3.10294C6.75303 2.65286 7.36348 2.4 8 2.4ZM8 13.76C7.05094 13.7618 6.11615 13.529 5.27874 13.0824C4.44133 12.6357 3.72726 11.9891 3.2 11.2C3.2 9.6 6.4 8.736 8 8.736C9.6 8.736 12.8 9.6 12.8 11.2C12.2746 11.9921 11.5613 12.6418 10.7238 13.0913C9.88625 13.5408 8.95051 13.776 8 13.776V13.76Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnedMembership);
export default __webpack_public_path__ + "static/media/owned_membership.d231bc70.svg";
export { ForwardRef as ReactComponent };